module.exports = __webpack_public_path__ + "1e4920a1e7ee1eea4c41a9ca9d596ac0.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/accessibility/wheelchair.svg
// module id = C3I1
// module chunks = 0